import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { PrivateRoutes } from 'src/routing';
import { routes_all } from './constants/constVariables';
import { lazy, useEffect } from 'react';
import { listPlants, onResponse } from './redux/features';
import { useDispatch } from 'react-redux';
import { baseApiCall } from './api/Api';
import { access_service } from './constants/url';
import useAuthorizationContext from './providers/AuthorizationHandler/useAuthorizationContext';
const ApiBasedInactivityCheck = lazy(() =>
	import('src/api/ApiBasedInactivityCheck')
);

export const App = () => {
	const dispatch = useDispatch();
	const { user } = useAuthorizationContext();
	useEffect(() => {
		if (user?.plants) {
			fetchPlantList();
		}
		dispatch(
			onResponse({
				isToaster: false,
				severity: '',
				message: '',
			})
		);
	}, [user?.plants]);

	const fetchPlantList = () => {
		baseApiCall({
			url: access_service.GET_PLANT_LIST,
			requestBody: {
				plants: user.plants,
			},
			method: 'POST',
			onSuccess: (res) => {
				const data = res.data.result;
				dispatch(listPlants(data));
			},
			onFailure: (res) => {},
			invalidCall: (res) => {},
			errorCall: (res) => {},
		});
	};
	return (
		<>
			<Router>
				<Routes>
					<Route element={<PrivateRoutes />}>
						{routes_all.map(({ path, Component }, key) => (
							<Route path={path} key={key} element={Component} exact />
						))}
					</Route>
				</Routes>
			</Router>
			<ApiBasedInactivityCheck />
		</>
	);
};
